import type { GameState } from "@dailywars/core/engine";

import type { GameSettings, StoreState } from "#/game/store/types";

export const DEFAULT_GAME_SETTINGS: GameSettings = {
  fastPlayback: false,
  endTurnConfirmation: true,
  disableAiPlayback: false,
  captureResetWarning: true,
};

export function buildInitialStoreState({
  initialState,
  initialServerDayNumber,
  settings,
  runVersion,
}: {
  initialState: GameState;
  initialServerDayNumber: number;
  settings: GameSettings;
  runVersion: 1 | 2;
}): StoreState {
  return {
    fastPlayback: settings.fastPlayback,
    endTurnConfirmation: settings.endTurnConfirmation,
    disableAiPlayback: settings.disableAiPlayback,
    captureResetWarning: settings.captureResetWarning,
    serverState: initialState,
    serverDayNumber: initialServerDayNumber,
    localState: initialState,
    pendingMoves: [],
    lastCycledUnitId: null,
    selection: { mode: "none" },
    animation: null,
    animationQueue: [],
    previewAnimation: null,
    isSubmitting: false,
    aiPlayback: null,
    hoveredTile: null,
    unmovedHighlight: null,
    scrollFocusTile: null,
    runVersion,
  };
}
